import { useState } from 'react'

import { useIntercom } from 'react-use-intercom'

import DownloadIcon from '@/assets/icons/icon-download.svg'
import { Button } from '@/components/ui/button'
import { Checkbox } from '@/components/ui/checkbox'
import { Dialog } from '@/components/ui/dialog'
import { CheckedState } from '@/components/ui/form/form-checkbox'
import { LocalStorageKeys } from '@/consts/localStorage'

import { DialogProps } from '../types'

export const CUIIntroDialog = ({ isOpen, onClose }: DialogProps) => {
  const [notShowAgain, setNotShowAgain] = useState<CheckedState>(false)
  const intercom = useIntercom()

  const handleDownloadPdf = () => {
    window.open(
      'https://drive.google.com/file/d/1lapLq5NMGUyrQ2UCbmYbbvBMN5ZecRPP/view',
      '_blank',
    )
  }

  const handleClose = () => {
    if (notShowAgain === true) {
      localStorage.setItem(
        LocalStorageKeys.CHATTING_INTRODUCTION_DIALOG_SHOWN,
        'true',
      )
    }
    sessionStorage.setItem(
      LocalStorageKeys.CHATTING_INTRODUCTION_DIALOG_SHOWN,
      'true',
    )
    onClose()
  }

  const handleIntercom = () => {
    intercom.showNewMessage('I have questions about the software.')
    onClose()
  }

  return (
    <Dialog
      bigDialog
      show={isOpen}
      onClose={handleClose}
      panelClassName="w-[800px] max-h-[95vh] overflow-auto"
    >
      <Dialog.Header>
        <Dialog.Title>
          <h3 className="text-3xl font-semibold text-secondary-500 dark:text-white">
            Chatting UI Introduction
          </h3>
          <p className="mt-2 text-sm font-normal text-secondary-300 dark:text-secondary-300">
            Unlock the full potential of CreatorHero by using the Chatting UI
            now with our instructions.
          </p>
        </Dialog.Title>
      </Dialog.Header>
      <Dialog.Description>
        <iframe
          src="https://www.loom.com/embed/5663cec09dca405898528432790264ee?sid=10c82fc8-c63e-412c-856d-4b7c3c81fd30&hideEmbedTopBar=true&hide_title=true&hide_share=true&hide_owner=true"
          frameBorder="0"
          allowFullScreen
          className="nsfw-ignore mt-6 h-[404px] w-full overflow-hidden rounded-3xl"
        />
        <div className="mt-4 flex flex-col items-center">
          <Button
            onClick={handleDownloadPdf}
            className="px-3"
            variant="default"
            size="lg"
          >
            Download PDF Now
            <DownloadIcon className="ml-1 h-6 w-6" />
          </Button>
          <label className="flex- mt-4 items-center gap-2">
            <Checkbox onCheckedChange={setNotShowAgain} />
            <span className="ml-2 text-xs text-secondary-300">
              Don&apos;t show this again
            </span>
          </label>
          <span className="mt-4 text-xs text-secondary-300">
            Got more questions regarding the Chatting UI?{' '}
            <Button
              onClick={handleIntercom}
              variant="link"
              size="sm"
              className="p-0 text-blue-500"
            >
              Ask our support team
            </Button>
          </span>
        </div>
      </Dialog.Description>
    </Dialog>
  )
}
